<template>
  <el-dialog :visible="visible" width="520px" custom-class="contact-group-dialog" append-to-body @close="$emit('close')">
    <div slot="title" class="dialog-title">
      <div class="title-icon"><i class="el-icon-folder-opened"></i></div>
      <div><div class="title-text">{{ title }}</div><div class="title-sub">共 {{ orderedGroups.length }} 个分组，拖动可调整顺序</div></div>
    </div>
    <div class="group-create">
      <el-input v-model.trim="newName" maxlength="32" placeholder="输入新分组名称"
        @keyup.enter.native="createGroup"></el-input>
      <el-button type="primary" icon="el-icon-plus" @click="createGroup">创建</el-button>
    </div>
    <div v-if="orderedGroups.length" class="group-list">
      <div v-for="(group, index) in orderedGroups" :key="group.id" class="group-row"
        :class="{ dragging: dragIndex === index }" :draggable="editingId !== group.id"
        @dragstart="onDragStart(index, $event)" @dragover.prevent @drop="onDrop(index)" @dragend="dragIndex = -1">
        <div class="drag-handle" title="拖动调整顺序"><i class="el-icon-rank"></i></div>
        <el-input v-if="editingId === group.id" v-model.trim="editingName" maxlength="32"
          @keyup.enter.native="saveGroup(group)"></el-input>
        <span v-else class="group-name">{{ group.name }}</span>
        <template v-if="editingId === group.id">
          <el-button type="text" @click="saveGroup(group)">保存</el-button>
          <el-button type="text" @click="editingId = 0">取消</el-button>
        </template>
        <template v-else>
          <el-button class="row-action" circle icon="el-icon-edit-outline" title="重命名" @click="startEdit(group)"></el-button>
          <el-button class="row-action danger" circle icon="el-icon-delete" title="删除" @click="removeGroup(group)"></el-button>
        </template>
      </div>
    </div>
    <div v-else class="empty"><i class="el-icon-folder-add empty-icon"></i><div>还没有分组</div><span>创建分组，让好友和会话更清晰</span></div>
    <div slot="footer"><el-button @click="$emit('close')">完成</el-button></div>
  </el-dialog>
</template>

<script>
export default {
  props: { visible: Boolean, groupType: { type: String, required: true } },
  data: () => ({ newName: '', editingId: 0, editingName: '', orderedGroups: [], dragIndex: -1 }),
  computed: {
    groups() { return this.contactGroupStore.groupsOf(this.groupType); },
    title() { return this.groupType === 'FRIEND' ? '好友分组管理' : '会话分组管理'; }
  },
  watch: {
    visible(value) { if (value) this.syncGroups(); },
    groups() { if (this.dragIndex < 0) this.syncGroups(); }
  },
  methods: {
    syncGroups() { this.orderedGroups = this.groups.map(g => ({ ...g })); },
    onDragStart(index, event) {
      this.dragIndex = index;
      event.dataTransfer.effectAllowed = 'move';
    },
    async onDrop(index) {
      if (this.dragIndex < 0 || this.dragIndex === index) return;
      const moved = this.orderedGroups.splice(this.dragIndex, 1)[0];
      this.orderedGroups.splice(index, 0, moved);
      this.dragIndex = -1;
      await this.contactGroupStore.reorder(this.groupType, this.orderedGroups.map(g => g.id));
      this.$message.success('分组顺序已保存');
    },
    async createGroup() {
      if (!this.newName) return this.$message.warning('请输入分组名称');
      await this.contactGroupStore.create(this.groupType, this.newName);
      this.newName = '';
    },
    startEdit(group) { this.editingId = group.id; this.editingName = group.name; },
    async saveGroup(group) {
      if (!this.editingName) return this.$message.warning('请输入分组名称');
      await this.contactGroupStore.update(group.id, this.editingName, group.sort);
      this.editingId = 0;
    },
    removeGroup(group) {
      this.$confirm(`删除“${group.name}”后，组内项目将回到未分组，是否继续？`, '删除分组', { type: 'warning' })
        .then(() => this.contactGroupStore.remove(group.id)).catch(() => {});
    }
  }
};
</script>

<style scoped>
.dialog-title{display:flex;align-items:center;gap:12px}.title-icon{width:42px;height:42px;border-radius:13px;display:flex;align-items:center;justify-content:center;background:rgba(62,69,215,.10);color:var(--im-color-primary);font-size:20px}.title-text{font-size:17px;font-weight:600;line-height:22px;color:var(--im-text-color,#303133)}.title-sub{margin-top:2px;font-size:12px;color:#909399}.group-create{display:flex;align-items:center;gap:10px;padding:12px;border-radius:14px;background:#f7f8fc}.group-create .el-input{flex:1}.group-list{max-height:390px;margin-top:16px;overflow-y:auto;padding-right:3px}.group-row{min-height:58px;margin-bottom:8px;padding:7px 9px;display:flex;align-items:center;gap:9px;border:1px solid rgba(0,0,0,.055);border-radius:13px;background:#fff;box-sizing:border-box;transition:opacity .15s,background .15s,box-shadow .15s}.group-row:hover{box-shadow:0 5px 18px rgba(31,36,75,.07)}.group-row.dragging{opacity:.45;background:#f5f7fa}.drag-handle{width:34px;height:34px;display:flex;align-items:center;justify-content:center;border-radius:10px;background:#f5f6fa;font-size:17px;color:#a0a3b1;cursor:move}.group-name{flex:1;min-width:0;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.group-row .el-input{flex:1}.row-action{width:34px;height:34px;padding:0;border:0;background:#f5f6fa;color:#60647a}.row-action.danger{margin-left:0;background:#fff1f1;color:#e66a6a}.empty{padding:48px 20px;text-align:center;color:#606266}.empty-icon{display:block;margin-bottom:12px;font-size:38px;color:#b5b8c8}.empty span{display:block;margin-top:7px;font-size:12px;color:#a0a3b1}
</style>
